module.exports = __webpack_public_path__ + "img/lease.cc17d7af.png";